import { FC } from 'react';
import { FlatProvider } from 'swo-ciam-common-react';

import { FeatureStorageProvider } from './feature-toggle/feature-storage';
import FlagsWithContextProvider from './flags/flags-with-context.provider';
import RouterWrapperProvider from './routing/components/router-wrapper.provider';

export const RootComponent: FC = () => {
  const coreProviders = [
    <FeatureStorageProvider />,
    <FlagsWithContextProvider />,
    <RouterWrapperProvider />,
  ];
  return <FlatProvider elements={coreProviders} />;
};
